export const ADD_TDPS = 'ADD_TDPS'
export const SET_TDPS = 'SET_TDPS'
export const SET_TDP = 'SET_TDP'
export const UPDATE_TDPS = 'UDPATE_TDPS'